import client from "./config";

//////////////// meta/ ////////////////
const url = "meta/";
export const getMetaTagsRequest = () => client.get(url);

export const updateMetaTagsRequest = (values) =>
  client.put(`${url}${values.slug}/`, values);
